import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Header } from '../../components/Header';
import { Load } from '../../components/Load';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import { Options, Select } from '../../components/Select';
import InputMask from 'react-input-mask';
import AlertMessage from '../../components/Alert';

import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import api from '../../services/api';
import './style.css';
import { useParams } from 'react-router-dom';


export function EmpresasEditar() {
    const { idEmpresa } = useParams();

    const [isLoading, setIsLoading] = useState(true);

    {/* Informações Gerais */ }
    const [cnpj, setCnpj] = useState("");
    const [cei, setCEI] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [cnae, setCnae] = useState("");
    const [telefone, setTelefone] = useState("");
    const [celular, setCelular] = useState("");
    const [site, setSite] = useState("");
    const [razaoSocial, setRazaoSocial] = useState("");
    const [email, setEmail] = useState('');

    {/* Informações Residenciais */ }
    const [cep, setCep] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [bairro, setBairro] = useState('');
    const [complemento, setComplemento] = useState('');
    const [estado, setEstado] = useState('');
    const [cidade, setCidade] = useState('');
    const [obs, setobs] = useState('');

    const [responsavelRelacionado, setResponsavelRelacionado]: any = useState(null);
    const [responsavelSelecionado, setResponsavelSelecionado] = useState(null);
    const [responsaveis, setResponsaveis]: any = useState(null);
    const [idResponsavel, setResponsavelId] = useState(null);

    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });

    useEffect(() => {
        const buscarDadosEmpresa = async () => {
            if (idEmpresa) {
                try {
                    const response = await api.get(`/empresas/listar/${idEmpresa}`);
                    const empresa = response.data;

                    setRazaoSocial(empresa.nome);
                    setCnpj(empresa.cnpj);
                    setCEI(empresa.cei);
                    setInscricaoEstadual(empresa.insc_estadual);
                    setCnae(empresa.cnae);
                    setTelefone(empresa.telefone);
                    setCelular(empresa.celular);
                    setCep(empresa.cep);
                    setEmail(empresa.email);
                    setEndereco(empresa.endereco);
                    setNumero(empresa.numero);
                    setBairro(empresa.bairro);
                    setComplemento(empresa.complemento);
                    setEstado(empresa.estado);
                    setCidade(empresa.cidade);
                    setSite(empresa.site)
                    setobs(empresa.obs);

                    const responseResponsaveis = await api.get('listar-responsaveis');
                    setResponsaveis(responseResponsaveis.data);

                    const responseResponsavelEmpresa = await api.get(`listar-responsavel-por-empresa/${idEmpresa}`);
                    setResponsavelRelacionado(responseResponsavelEmpresa.data[0].id);
                    setResponsavelSelecionado(responseResponsavelEmpresa.data[0].id);

                } catch (error) {
                    console.error('Erro ao buscar dados da empresa', error);
                }

            }
        };

        buscarDadosEmpresa();
    }, [idEmpresa]);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseResponsaveis = await api.get('listar-responsaveis');
                setResponsaveis(responseResponsaveis.data);


            } catch (error) {
                console.error('Erro ao buscar dados da empresa', error);
            }
        };
        fetchData();
    }, [idEmpresa]);

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        setIsLoading(true); 

        const payload = {
            cnpj,
            nome: razaoSocial,
            cei,
            cnae,
            insc_estadual: inscricaoEstadual,
            telefone,
            celular,
            site,
            cep,
            endereco,
            numero,
            bairro,
            complemento,
            estado,
            cidade,
            obs,
            email,
            id_responsavel: idResponsavel
        };

        let isValid = true;

        if (!razaoSocial) {
            setAlert({ message: 'Por favor, preencha o campo razão social', variant: 'danger', show: true });
            isValid = false;
        }
        if (!cnpj) {
            setAlert({ message: 'Por favor, preencha o campo CNPJ.', variant: 'danger', show: true });
            isValid = false;
        }

        if (!isValid) {
            setIsLoading(false); 
            return;
        }

        try {
            await api.put(`/empresas/editar/${idEmpresa}`, payload);
            setAlert({ message: 'Empresa atualizada com sucesso!', variant: 'success', show: true });
        } catch (error) {
            setAlert({ message: 'Erro ao atualizar a empresa.', variant: 'danger', show: true });
            console.error('Erro ao atualizar dados da empresa:', error);
        } finally {
            setIsLoading(false); 
        }
    };

    const handleCepChange = async (e: any) => {
        const cep = e.target.value.replace(/\D/g, '');
        setCep(cep);

        if (cep.length === 8) {
            try {
                const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
                const { logradouro, bairro, localidade, uf } = response.data;

                setEndereco(logradouro);
                setBairro(bairro);
                setEstado(uf);
                setCidade(localidade);
            } catch (error) {
                console.error('Erro ao buscar o CEP', error);
            }
        }
    };

    const handleSelectResponsavel = (id: any) => {
        setResponsavelId(id);
    };

    return (
        <div>
            <Load isLoading={isLoading} />
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Editar Empresa</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Razão Social' htmlFor="razao_social" />
                                <input
                                    type="text"
                                    id="razao_social"
                                    placeholder="Digite a Razão Social"
                                    value={razaoSocial}
                                    onChange={(e) => {
                                        setRazaoSocial(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='CNPJ' htmlFor="cnpj" />
                                <InputMask
                                    mask="**.***.***/****-99"
                                    id='cnpj'
                                    value={cnpj}
                                    onChange={(e: any) => setCnpj(e.target.value.toUpperCase())}
                                    placeholder="Digite o CNPJ"
                                    style={{ width: '100%', textTransform: 'uppercase' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='CEI' htmlFor="cei" />
                                <InputMask
                                    value={cei}
                                    onChange={(e: any) => setCEI(e.target.value)}
                                    placeholder="Digite o CEI"
                                    className="form-control"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='CNAE' htmlFor="cnae" />
                                <InputMask
                                    mask="9999-9/99"
                                    type="text"
                                    id="cnae"
                                    placeholder="Digite o CNAE"
                                    value={cnae}
                                    onChange={(e: any) => setCnae(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Inscrição Estadual' htmlFor="cnpj" />
                                <InputMask
                                    id='inscricao_estadual'
                                    value={inscricaoEstadual}
                                    onChange={(e: any) => setInscricaoEstadual(e.target.value)}
                                    placeholder="Digite a Inscrição Estadual"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='E-mail' htmlFor="email" />
                                <input
                                    type="text"
                                    id="email"
                                    placeholder="Digite o E-mail"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Telefone' htmlFor="telefone" />
                                <InputMask
                                    mask="(99) 9999-9999"
                                    value={telefone}
                                    onChange={(e: any) => setTelefone(e.target.value)}
                                    placeholder="(__) ____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Celular' htmlFor="celular" />
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={celular}
                                    onChange={(e: any) => setCelular(e.target.value)}
                                    placeholder="(__) _____-____"
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3} xl={3}>
                            <FormGroup>
                                <Label title='Site' htmlFor="site" />
                                <InputMask
                                    value={site}
                                    onChange={(e: any) => setSite(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <h3>Endereço</h3>
                    <Row>
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <Label title='CEP' htmlFor="cep" />
                                <InputMask
                                    mask="99999-999"
                                    type="text"
                                    id="cep"
                                    placeholder="Digite o CEP"
                                    value={cep}
                                    onChange={handleCepChange}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Endereço' htmlFor="endereco" />
                                <input
                                    type="text"
                                    id="endereco"
                                    placeholder="Endereço"
                                    value={endereco}
                                    onChange={(e) => setEndereco(e.target.value)}
                                    style={{ width: '100%' }}

                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={3}>
                            <FormGroup>
                                <Label title='Número' htmlFor="numero" />
                                <input
                                    type="text"
                                    id="numero"
                                    placeholder="Número"
                                    value={numero}
                                    onChange={(e) => setNumero(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className='my-4'>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Bairro' htmlFor="bairro" />
                                <input
                                    type="text"
                                    id="bairro"
                                    placeholder="Bairro"
                                    value={bairro}
                                    onChange={(e) => setBairro(e.target.value)}
                                    style={{ width: '100%' }}

                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Complemento' htmlFor="complemento" />
                                <input
                                    type="text"
                                    id="complemento"
                                    placeholder="Complemento"
                                    value={complemento}
                                    onChange={(e) => setComplemento(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Cidade' htmlFor="cidade" />
                                <input
                                    type="text"
                                    id="cidade"
                                    placeholder="Cidade"
                                    value={cidade}
                                    onChange={(e) => setCidade(e.target.value)}
                                    style={{ width: '100%' }}

                                />
                            </FormGroup>
                        </Col>

                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Label title='Estado' htmlFor="estado" />
                                <input
                                    type="text"
                                    id="estado"
                                    placeholder="Estado"
                                    value={estado}
                                    onChange={(e) => setEstado(e.target.value)}
                                    style={{ width: '100%' }}

                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <h3 style={{ marginTop: '10px' }}>Responsável - PGR</h3>
                    <Row>
                        <Col xs={12} md={6}>
                            <FormGroup>
                                <Select id="selectResponsavel" onSelect={handleSelectResponsavel}>
                                    {responsaveis && responsaveis.map((responsavel: any) => (
                                        <Options
                                            key={responsavel.id}
                                            value={responsavel.id}
                                            name={responsavel.nome}
                                            defaultValue={responsavelRelacionado}
                                            selected={responsavel.id === responsavelSelecionado}
                                        />
                                    ))}
                                </Select>
                            </FormGroup>
                        </Col>

                    </Row>

                    <Row className='mt-4'>
                        <Col xs={12}>
                            <FormGroup>
                                <Label title='Observações' htmlFor="obs" />
                                <textarea
                                    id="obs"
                                    placeholder="Digite observações"
                                    value={obs}
                                    onChange={(e) => setobs(e.target.value)}
                                    style={{ width: '100%', minHeight: '100px' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Button className="btn-main mt-4" type="submit">Salvar</Button>
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
